import React from 'react';
import axios from 'axios'
import { toast } from 'react-toastify'
import { accessManagementBaseURL, baseURL, predictionBaseURL } from './config'
import { Auth } from 'aws-amplify'

axios.defaults.baseURL = baseURL

const axiosInstance = axios.create({
  baseURL: baseURL,
})


const predictionsServicePrefix = '/prediction-services'
const accessManagementServicePrefix = '/management'

axiosInstance.interceptors.request.use(async (config) => {

  if (config.url.startsWith(predictionsServicePrefix)) {
    config.baseURL = predictionBaseURL
  } else if (config.url.startsWith(accessManagementServicePrefix)) {
    config.baseURL = accessManagementBaseURL
  }

  const session = await Auth.currentSession()
  if (session) {
    const token = session.getIdToken().getJwtToken()
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

const serverErrorMessage =
  'Sorry, but an unexpected error has occurred. Our team is working to resolve it as quickly as possible.'

const ErrorWithDetails = ({ message, details }) => (
  <span>
    <span>{message}</span>
    <hr />
    <span>
      Details: <strong>{details}</strong>
    </span>
  </span>
)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.code === 'ERR_CANCELED') {
      return Promise.reject(error.code)
    }

    if (error?.code === 'ERR_NETWORK') {
      toast.error('Network error, unable to access backend');
      return;
    }

    const { data, status } = error.response || {}
    const message = data?.message
    const messages = data?.messages || []
    const isServerError = status >= 500 && status < 600

    if (!error.config.withoutErrorToast) {
      if (isServerError) {
        toast.error(serverErrorMessage)
        console.error('error', data?.details);
        console.error('message', message);
        console.error('messages', messages);
      } else if (status === 403) {
        toast.error("You don’t have the required permissions to do this action, please contact the support team")
      } else {
        if (!message && !messages.length) toast.error(serverErrorMessage)
        if (message) {
          if (data?.details) {
            toast.error(
              <ErrorWithDetails message={message} details={data?.details} />
            )
          } else {
            toast.error(message)
          }
        }
        messages.forEach((msg) => toast.error(msg))
      }
    }
    return Promise.reject(data || serverErrorMessage)
  }
)

export default axiosInstance
